import type { FormattedItem } from '../../../types';

/**
 * Takes a LineItem and structures it in a way that the f/e expects
 * @param lineItem
 */
export default function useLineItemValues(
  lineItem: FormattedItem,
): FormattedItem {
  const title = lineItem?.title || 'No line item title given...';

  const values = {
    title,
    key: title,
    description: lineItem?.description || null,
    quantity: lineItem?.quantity || null,
    price: lineItem?.price || null,
    vat: lineItem?.vat || null,
    total: lineItem?.total || null,
  };

  return values;
}
